import { VueExtension } from '../../utils/extensions/vue';
import Checkbox from './checkbox.jsx';
import './checkbox.scss';

VueExtension.WithInstall(Checkbox);

export default Checkbox;
